import { FC } from 'react';
import styled from 'styled-components';
import { Button, Stack, Typography } from '@mui/material';
import { PageNotFoundIllustration } from '@vs-online-only-app/ui';

const Container = styled(Stack)`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.background.paper};
`;

const Card = styled(Stack)`
  background-color: ${({ theme }) => theme.palette.background.default};
  padding: ${({ theme }) => theme.spacing(3)};
  max-width: 400px;
  align-items: center;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
`;

const PageNotFoundView: FC = () => (
  <Container>
    <Card>
      <PageNotFoundIllustration />
      <Stack gap={3}>
        <Stack>
          <Typography variant="h6" align="center">
            Page not Found
          </Typography>
          <Typography align="center">
            We&apos;re sorry, but we can&apos;t seem to find the page
            you&apos;re looking for.
          </Typography>
        </Stack>
        <Button href={'/'} variant="contained" fullWidth>
          Return to home
        </Button>
      </Stack>
    </Card>
  </Container>
);

export default PageNotFoundView;
